var OrSkeletonTextSizes;
(function (OrSkeletonTextSizes) {
  OrSkeletonTextSizes["headline1"] = "headline-1";
  OrSkeletonTextSizes["headline2"] = "headline-2";
  OrSkeletonTextSizes["headline3"] = "headline-3";
  OrSkeletonTextSizes["body1"] = "body-1";
  OrSkeletonTextSizes["body2"] = "body-2";
  OrSkeletonTextSizes["button"] = "button";
  OrSkeletonTextSizes["caption"] = "caption";
})(OrSkeletonTextSizes || (OrSkeletonTextSizes = {}));

export { OrSkeletonTextSizes as O };
